import {styled} from '@linaria/react';
import React, {FC, useRef} from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_WEIGHTS} from '../../../constants/typography';
import {useIsomorphicLayoutEffect} from '../../../hooks/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';
import {BreadcrumbItem} from '../../molecules/Breadcrumb/BreadcrumbItem';

interface BreadCrumbsProps {
  links: {
    path: string;
    label: string;
  }[];
  className?: string;
  scrollable?: boolean;
}

const BreadCrumbsContainer = styled.div`
  text-align: left;
`;

const List = styled.ul`
  align-items: baseline;
  color: ${COLORS.Grey1};
  line-height: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  > li:last-of-type > a {
    font-weight: ${FONT_WEIGHTS.bold};
  }

  &[data-scrollable='true'] {
    overflow: auto;
    text-overflow: initial;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Breadcrumbs: FC<BreadCrumbsProps> = ({
  links,
  className,
  scrollable,
}) => {
  const ref = useRef<HTMLUListElement>(null);

  useIsomorphicLayoutEffect(() => {
    if (ref.current && scrollable) {
      ref.current.scroll({
        left: ref.current.scrollWidth,
        behavior: 'instant',
      });
    }
  }, [scrollable]);

  return (
    <BreadCrumbsContainer className={className}>
      <List data-testid="Breadcrumbs" ref={ref} data-scrollable={scrollable}>
        {links.map((link, index) => (
          <BreadcrumbItem key={index} index={index} link={link} />
        ))}
      </List>
    </BreadCrumbsContainer>
  );
};
